<template>
  <section :class="cssClass">
    <no-ssr>
      <carousel
        :per-page="1"
        :autoplay="true"
        :per-page-custom="perPageCustom"
        :pagination-enabled="false"
        :autoplay-hover-pause="true"
        :loop="true"
        :scroll-per-page="false"
        :autoplay-timeout="3000"
        :speed="1000"
      >
        <slide v-for="(slide, index) in manufacturers" :key="index">
          <router-link
            :to="localizedRoute(getBrandUrl(slide))"
            class="item no-underline"
            v-if="slide._source.logo !== ''"
            v-lazy:background-image="`https://atmedia.systemb2b.pl/uploads/pictures/brands/` + slide._source.logo"
            :title="slide._source.name"
          />
          <router-link
            :to="localizedRoute(getBrandUrl(slide))"
            class="item no-underline"
            v-else
          >
            {{ slide._source.name }}
          </router-link>
        </slide>
      </carousel>
    </no-ssr>
  </section>
</template>
<script>
import NoSSR from 'vue-no-ssr';
import fetch from 'isomorphic-fetch';
import RootCateogry from 'theme/mixins/rootCategory';
import config from 'config'
export default {
  name: 'ManufacturerSlider',
  components: {
    Carousel: () => import('vue-carousel').then(Slider => Slider.Carousel),
    Slide: () => import('vue-carousel').then(Slider => Slider.Slide),
    'no-ssr': NoSSR
  },
  created () {
    this.getBrandsFromApi();
  },
  data () {
    return {
      manufacturers: [],
      perPageCustom: [
        [400, 2],
        [768, 3],
        [1024, 6],
        [1200, 10],
        [1400, 12]
      ]
    };
  },
  mixins: [RootCateogry],
  props: {
    cssClass: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  mounted () {},
  methods: {
    getBrandUrl (slide) {
      let slug = this.getRootCategorySlug;
      if (slug) {
        return `/produkty-marki/${slide._source.name}/${slug}`;
      } else {
        return `/produkty-marki/${slide._source.name}/`;
      }
    },
    async getBrandsFromApi () {
      var vm = this;
      await fetch(`${config.api.url}/api/catalog/${config.elasticsearch.index}/brands/_search?q=is_featured:true&size=200`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(resp => resp.json())
        .then(data => {
          // console.log(this.getRootCategorySlug);
          if (data.hits.hits === 'undefined') {
            return false;
          }
          if (this.getRootCategorySlug) {
            vm.manufacturers = data.hits.hits.filter(s => {
              if (typeof s._source[this.getRootCategorySlug] !== 'undefined' && s._source[this.getRootCategorySlug] > 0) {
                return true;
              }
              return false;
            });
          } else {
            vm.manufacturers = data.hits.hits.filter(s => {
              if (s._source.products_count > 0) {
                return true
              }
              return false;
            });
          }
        })
        .catch(error => {
          throw new Error('ManufacturerSlider, Error: ' + error.toString());
        });
    }
  }
};
</script>
<style lang="scss" scope>
.manufacturer-slider {
  border-top: solid 1px #cbd3dd;
  .VueCarousel {
    .VueCarousel-wrapper {
      .VueCarousel-slide {
        .item {
          box-sizing: border-box;
          margin: 20px 10px;
          padding: 0px 0px;
          height: 79px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          display: block;
          &:hover {
            border: none;
          }
          &:hover::after {
            background-color: transparent !important;
          }
        }
      }
    }
  }
}
</style>
